export const getDataRequested = (state, slug) => {
    return state.getIn(["articlesData", slug, "dataRequested"], false);
};
export const getDataReceived = (state, slug) => {
    return state.getIn(["articlesData", slug, "dataReceived"], false);
};
